export default __webpack_public_path__ + "static/media/GLOTrackGrey.a6746eca.svg";